<template>
  <v-dialog v-model="value" max-width="500px" persistent>
    <v-card>
      <v-card-title>
        <span v-if="serviceAreaAttribute.id" class="headline font-weight-thin"
          >Edit {{ serviceAreaAttributeName }}</span
        >
        <span v-else class="headline font-weight-thin">Create New Service Area Attribute</span>
      </v-card-title>
      <v-form v-model="valid" ref="form">
        <v-card-text>
          <v-text-field
            :rules="nameRules"
            clearable
            data-cy="attributeForm__attributeName"
            label="Service Area Attribute Name"
            required
            v-model="serviceAreaAttribute.name"
          ></v-text-field>
          <v-checkbox
            :false-value="0"
            :true-value="1"
            data-cy="attributeForm__checkbox--deprecated"
            label="Deprecated"
            v-model="serviceAreaAttributeIsDeprecated"
          ></v-checkbox>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close" outlined data-cy="attributeForm_cancelBtn">Cancel</v-btn>
          <v-btn @click="save" :disabled="!valid" color="primary" data-cy="attributeForm__saveBtn">Save</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  computed: {
    serviceAreaAttributeIsDeprecated: {
      get() {
        return this.serviceAreaAttribute.isDeprecated;
      },
      set(val) {
        this.serviceAreaAttribute.isDeprecated = val;
      },
    },
    ...mapState({
      serviceAreaAttribute: state => state.admin.serviceAreaAttribute.record,
    }),
  },
  data() {
    return {
      serviceAreaAttributeName: null,
      categoryId: parseInt(this.$route.params.id, 10),
      nameRules: [
        name => !!name || "Name is required",
        () => this.validateUniqueConstraint() || "Name must be unique.",
      ],
      valid: true,
    };
  },
  methods: {
    checkForNameConflict() {
      const conflict = this.attributeList.find(attribute => {
        const nameMatch =
          `${attribute.name}`.trim().toUpperCase() === `${this.serviceAreaAttribute.name}`.trim().toUpperCase();
        return nameMatch && !(attribute.id === this.serviceAreaAttribute.id);
      });
      return conflict ? true : false;
    },
    close() {
      this.$emit("input", false);
    },
    async save() {
      if (this.serviceAreaAttribute.id) {
        try {
          // EDIT
          await this.updateServiceAreaAttribute(this.serviceAreaAttribute);
        } catch (e) {
          console.error(e);
          this.updateAttributeError();
        }
      } else {
        try {
          // CREATE
          this.serviceAreaAttribute.categoryId = this.categoryId;
          await this.createServiceAreaAttribute(this.serviceAreaAttribute);
        } catch (e) {
          console.error(e);
          this.createAttributeError();
        }
      }
      this.close();
    },
    validateUniqueConstraint() {
      if (!this.serviceAreaAttribute.name || !this.$refs.form) return true;
      return this.checkForNameConflict() ? false : true;
    },
    ...mapActions({
      createServiceAreaAttribute: "admin/serviceAreaAttribute/create",
      updateServiceAreaAttribute: "admin/serviceAreaAttribute/update",
    }),
  },
  notifications: {
    createAttributeError: {
      title: "Error!",
      message: "There was an error creating a new attribute.",
      type: "error",
    },
    updateAttributeError: {
      title: "Error!",
      message: "There was an error updating the attribute.",
      type: "error",
    },
  },
  props: ["value", "attributeList"],
  watch: {
    value(val) {
      this.$refs.form.resetValidation();
      if (!val) {
        return;
      }
      this.serviceAreaAttributeName = this.serviceAreaAttribute.name;
      this.serviceAreaAttributeIsDeprecated = this.serviceAreaAttribute.isDeprecated;
    },
  },
};
</script>
